import { createFileRoute, Navigate } from '@tanstack/react-router'
import { RoleRestrictedContent } from '@/components/molecules/RoleRestrictedContent/RoleRestrictedContent'
import { UserType } from '@/hooks'
import { EnergySourcingContracts } from '@/features/DataManagement/components/EnergySourcingContracts/EnergySourcingContracts'
import { useFeatureFlag } from '@/components/providers/FeatureFlagsProvider/useFeatureFlag'
import { energySourcingContractsSearchSchema } from '@/schemas'

export const Route = createFileRoute(
    '/_layout/data-management/energy-sourcing-and-contracts'
)({
    component: RouteComponent,
    validateSearch: energySourcingContractsSearchSchema,
})

function RouteComponent() {
    const isDataManagementEnabled = useFeatureFlag('dataManagement')

    if (!isDataManagementEnabled) {
        return <Navigate to="/dashboard" />
    }

    return (
        <>
            <RoleRestrictedContent
                allowedRoles={[UserType.AGENT, UserType.BROKER]}
            >
                <Navigate to={'/dashboard'} />
            </RoleRestrictedContent>

            <RoleRestrictedContent
                allowedRoles={[UserType.CUSTOMER]}
                strict={false}
            >
                <EnergySourcingContracts />
            </RoleRestrictedContent>
        </>
    )
}
